var render = function () {
  var _vm$user;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "500",
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": require("@/assets/undraw_female_avatar_w3jk.svg"),
      "alt": _vm.user.lastName,
      "height": "300px",
      "dark": ""
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-card-title', [_c('v-spacer')], 1), _c('v-spacer'), _c('v-card-title', {
    staticClass: "white--text pl-12 pt-12"
  }, [_c('div', {
    staticClass: "display-1 pl-12 pt-12"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])])], 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-card-title', [_vm._v("User")]), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-account")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.user.userName, "")))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.userName")))])], 1)], 1), _c('v-divider'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.profile.ProfileCard.contactSubtitle")) + " "), _c('v-spacer'), _c('edit-profile-dialog', {
    attrs: {
      "isLoading": _vm.isUpdatingUser,
      "userToUpdate": _vm.user
    },
    on: {
      "updateUser": _vm.updateUser
    }
  })], 1), (_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.company ? [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-vpn")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.user.company, "Kein Firma")))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.company")))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-identifier")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.user.taxnumber, "Bitte nachtragen")))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.taxnumber")))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  })] : _vm._e(), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.contact.phone, "")))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.telephone")))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.contact.email)))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.email")))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.street)) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.zip)) + " " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.address.city)) + " ")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.address.state)))])], 1)], 1), _vm.$can(_vm.ActionEnum.READ, _vm.ResourceEnum.THG) && _vm.isBankingAvailable ? [_c('v-divider'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.profile.ProfileCard.bankingSubtilte")) + " "), _c('v-spacer'), _c('create-or-update-bank-dialog')], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-account-cash")])], 1), _vm.isLoadingBanking ? _c('v-list-item-content', [_c('v-list-item-title', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1) : _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.banking.bank, "Keine Bankverbindung angegeben.")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$helpers.showValueWithDefault(_vm.banking.iban)) + " ")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$helpers.showValueWithDefault(_vm.banking.name)))])], 1)], 1)] : _vm._e(), _c('v-divider'), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.profile.ProfileCard.notification")) + " "), _c('v-spacer')], 1), _c('v-checkbox', {
    staticClass: "mx-4 my-n2",
    attrs: {
      "disabled": "",
      "label": _vm.$t('components.profile.ProfileCard.notificationTypes.system')
    },
    model: {
      value: _vm.isSystemEmail,
      callback: function callback($$v) {
        _vm.isSystemEmail = $$v;
      },
      expression: "isSystemEmail"
    }
  }), _c('v-checkbox', {
    staticClass: "mx-4 my-n2",
    attrs: {
      "disabled": _vm.isUpdatingUser,
      "label": _vm.$t('components.profile.ProfileCard.notificationTypes.news')
    },
    on: {
      "change": function change($event) {
        return _vm.updateUser(_vm.user);
      }
    },
    model: {
      value: _vm.user.isMarketingOptIn,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isMarketingOptIn", $$v);
      },
      expression: "user.isMarketingOptIn"
    }
  }), _vm.$can(_vm.ActionEnum.READ, _vm.ResourceEnum.PARTNER) ? [_c('v-divider'), _c('v-card-title', [_vm._v(" Permissions ")]), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("mdi-shield-key-outline")])], 1), _c('v-list-item-title', [_c('a', {
    on: {
      "click": _vm.goToPermissions
    }
  }, [_vm._v(_vm._s(_vm.$t("components.profile.ProfileCard.permissions")))])])], 1)] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }